module.exports = __webpack_public_path__ + "static/media/circulatory-system-diseases-icon.4a888e81.svg";